import { Headers as Headers$1 } from 'whatwg-fetch';
import uuid from 'uuid';
import qs from 'querystring';
import { Logger } from '@cvent/nucleus-logging';

if (!global.Headers && Headers$1) {
  global.Headers = Headers$1;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var httpLogPageLoadId = uuid.v4();

var HTTP_REQUEST_ID = 'HttpLogRequestId';
var HTTP_PAGE_ID = 'HttpLogPageLoadId';
/**

 *  Builder class for fetch api Request objects.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/Request/Request
 **/

var RequestBuilder =
/*#__PURE__*/
function () {
  function RequestBuilder(requestOptions) {
    _classCallCheck(this, RequestBuilder);

    var requestHeaders = requestOptions.headers ? new Headers(requestOptions.headers) : new Headers();

    if (!requestHeaders.has(HTTP_PAGE_ID)) {
      // allow user code to provide there own pageload id if they want.
      requestHeaders.set(HTTP_PAGE_ID, httpLogPageLoadId);
    }

    this.requestOptions = Object.assign({}, requestOptions, {
      headers: requestHeaders
    });
  }
  /* sets credentials to allow */


  _createClass(RequestBuilder, [{
    key: "withCookies",
    value: function withCookies() {
      // we're doing everything via CORS now so there is no use case for 'same-origin'
      return new RequestBuilder(Object.assign({}, this.requestOptions, {
        credentials: 'include'
      }));
    }
    /* Return a builder with a url set to url */

  }, {
    key: "url",
    value: function url(_url) {
      return new RequestBuilder(Object.assign({}, this.requestOptions, {
        url: _url
      }));
    }
    /* Return a builder with the HTTP method for request set to POST */

  }, {
    key: "post",
    value: function post() {
      return this.method('POST');
    }
    /* Return a builder with the HTTP method for request set to GET */

  }, {
    key: "get",
    value: function get() {
      return this.method('GET');
    }
    /* Return a builder with the HTTP method for request set to PUT */

  }, {
    key: "put",
    value: function put() {
      return this.method('PUT');
    }
    /* Return a builder with the HTTP method for request set to DELETE */

  }, {
    key: "delete",
    value: function _delete() {
      return this.method('DELETE');
    }
    /* Return a builder with the HTTP method for request set to OPTIONS */

  }, {
    key: "options",
    value: function options() {
      return this.method('OPTIONS');
    }
    /* Return a builder with the HTTP method for request built by the builder. */

  }, {
    key: "method",
    value: function method(_method) {
      return new RequestBuilder(Object.assign({}, this.requestOptions, {
        method: _method
      }));
    }
    /** Return a builder with the auth token set the Autorization header **/

  }, {
    key: "auth",
    value: function auth(token) {
      return this.header('Authorization', token);
    } // TODO  consider adding path param function.

    /**
     * Return a builder with the query param. If the param value is an array the
     * param will appear for each value in the array.
     */

  }, {
    key: "query",
    value: function query(param, value) {
      var url = this.requestOptions.url;
      var base = url.split('?')[0];
      var search = qs.parse(url.split('?')[1]);
      search[param] = value;
      return this.url("".concat(base, "?").concat(qs.stringify(search)));
    }
    /* Return a builder with the json string of value set as the request body */

  }, {
    key: "json",
    value: function json(value) {
      var body = JSON.stringify(value);
      return this.header('Content-Type', 'application/json').body(body);
    }
    /* Return a builder with a set request body */

  }, {
    key: "body",
    value: function body(value) {
      return new RequestBuilder(Object.assign({}, this.requestOptions, {
        body: value
      }));
    }
    /* Return a builder with a header set to value */

  }, {
    key: "header",
    value: function header(_header, value) {
      var headers = this.requestOptions.headers ? new Headers(this.requestOptions.headers) : new Headers();
      headers.set(_header, value);
      return new RequestBuilder(Object.assign({}, this.requestOptions, {
        headers: headers
      }));
    }
    /* Build a fetch Request object */
    // https://developer.mozilla.org/en-US/docs/Web/API/Request

  }, {
    key: "build",
    value: function build() {
      var url = this.requestOptions.url;
      var requestHeaders = this.requestOptions.headers ? new Headers(this.requestOptions.headers) : new Headers();

      if (!requestHeaders.has(HTTP_REQUEST_ID)) {
        requestHeaders.set(HTTP_REQUEST_ID, uuid.v4());
      }

      var request = new Request(url, Object.assign({}, this.requestOptions, {
        headers: requestHeaders
      }));
      return request;
    }
  }]);

  return RequestBuilder;
}();

var LOG = new Logger('RequestBuilder');

var pause = function pause(milliseconds) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      return resolve();
    }, milliseconds);
  });
};
/**
 * Wrapper for the fetch api that takes additional options around how to deal with
 * server too busy conditions
 * @param request - The fetch request created from the RequestBuilder.
 * @param options.initialDelay - number of milliseconds to wait if the 1st call is a 429
 * @param options.multiplactionFactor - exponential back off
 * @param options.maxDelay - longest time to delay in milliseconds before just returning a response.
 **/


function fetchAndRetryIfServerBusy(request) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$initialDelay = options.initialDelay,
      initialDelay = _options$initialDelay === void 0 ? 1000 : _options$initialDelay,
      _options$multiplactio = options.multiplactionFactor,
      multiplactionFactor = _options$multiplactio === void 0 ? 2 : _options$multiplactio,
      _options$maxDelay = options.maxDelay,
      maxDelay = _options$maxDelay === void 0 ? 64000 : _options$maxDelay;
  var delay = initialDelay;

  function checkAndFetch() {
    return fetch(request).then(function (response) {
      if (delay > maxDelay || response.status !== 429) {
        return response;
      }

      LOG.warn("server was busy, retrying again in ".concat(delay, " MS. { url: ").concat(request.url, ", method: ").concat(request.method, "}"));
      var newResponse = pause(delay).then(checkAndFetch);
      delay = delay * multiplactionFactor;
      return newResponse;
    });
  }

  return checkAndFetch().then(function (response) {
    if (response.status === 429) {
      LOG.warn("max retries reached, giving up. ".concat(delay, " MS. { url: ").concat(request.url, ", method: ").concat(request.method, "}"));
    }

    return response;
  });
}

export { RequestBuilder, httpLogPageLoadId, fetchAndRetryIfServerBusy };
//# sourceMappingURL=index.js.map
